import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-group-folders-icon',
  templateUrl: './files-group-folders.component.html'
})
export class FilesGroupFoldersComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
